<marv-drawer #drawerPhoto size="big" [noPadding]="true" (onDidDismiss)="this.closeDrawer()">
    @if(this.photo){
        <div id="modal_photo_content">            
                 
            <marv-button id="modal_photo_button_download" icon="download-outline" [rounded]="true" (click)="this.downloadPhoto()" />  
            
            <div id="modal_photo_img">
                <marv-img [src]="this.photo.urlPicture" objectFit="contain"/>
            </div>
                  
            <div id="modal_photo_footer">
                          
                <div id="modal_photo_store">
                    <app-retailer-logo [retailer]="this.retailerLogo"/>
                    <div id="modal_photo_store_name">{{this.photo.store.name}}</div>
                </div>
                
                <marv-button icon="chevron-back-outline" [rounded]="true" [disabled]="[-1, 0].indexOf(this.indexPhoto) !== -1" (click)="this.previousPhoto()" />  
                
                <div id="modal_photo_infos">                    
                    <div id="modal_photo_date">{{this.photo.day | epochToString: 'dddd DD/MM/YYYY'}}</div>
                    <div id="modal_photo_operation">
                        <marv-tag [color]="this.missionTypeService.getColor(photo.operation.typeOfMission)" size="small">{{this.photo.operation.name}}</marv-tag>
                    </div>
                    @if(photo.modelName !== ''){
                        <div id="modal_photo_model">{{this.photo.modelName}}</div>
                    }
                    @if(photo.tagName !== ''){
                        <div id="modal_photo_tag">{{this.photo.tagName}}</div>
                    }
                </div>
            
                <marv-button icon="chevron-forward-outline" [rounded]="true" [disabled]="[-1, (this.photos.length-1)].indexOf(this.indexPhoto) !== -1" (click)="this.nextPhoto()" />  
                
            </div>
            
        </div>
    }
</marv-drawer>